import api from "src/api/axios";

const createPlasticSeal = async (input) => {
  return api.post(`/plastic-seals`, input).then((result) => {
    return result.data;
  });
};

const updatePlasticSeal = async (input, id) => {
  return api.patch(`/plastic-seals/${id}`, input).then((result) => {
    return result.data;
  });
};

const updatePlasticSealStatus = async (input, id) => {
  return api
    .patch(`/plastic-seals/update-status/${id}`, input)
    .then((result) => {
      return result.data;
    });
};

const getPlasticSealList = async (urlParams) => {
  const params = new URLSearchParams();
  for (const key in urlParams) {
    if (urlParams.hasOwnProperty(key)) {
      const value = urlParams[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        params.append(key, value);
      }
    }
  }

  return api.get(`/plastic-seals?${params}`).then((result) => {
    return result.data;
  });
};

const getExportablePlasticSealList = async (param) => {
  const params = new URLSearchParams(param);
  return api.get(`/plastic-seals/export?${params}`).then((result) => {
    return result.data;
  });
};

const getSearchedPlasticSealList = async ({
  limit,
  page,
  searchedString,
  country,
}) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
    serial: searchedString ? searchedString : "",
    country: country ? country : "",
  });
  return api.get(`/plastic-seals/search?${params}`).then((result) => {
    return result.data;
  });
};

const getUsedSearchedPlasticSealList = async ({
  limit,
  page,
  searchedString,
  country,
}) => {
  const params = new URLSearchParams({
    page: page ? page : "1",
    limit: limit ? limit : "10",
  });
  if (searchedString) params.append("serial", searchedString);
  if (country) params.append("country", country);
  return api.get(`/plastic-seals/used?${params}`).then((result) => {
    return result.data;
  });
};

const getSinglePlasticSeal = async (id) => {
  return api.get(`/plastic-seals/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createPlasticSeal,
  getPlasticSealList,
  getSinglePlasticSeal,
  updatePlasticSeal,
  getSearchedPlasticSealList,
  updatePlasticSealStatus,
  getExportablePlasticSealList,
  getUsedSearchedPlasticSealList,
};
